import { render, staticRenderFns } from "./Categorias.vue?vue&type=template&id=b7c3b166&"
import script from "./Categorias.vue?vue&type=script&lang=js&"
export * from "./Categorias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QToolbar,QBreadcrumbs,QBreadcrumbsEl,QSpace,QBtn,QTable,QCard,QItem,QItemSection,QAvatar,QItemLabel,QSeparator,QCardSection,QImg,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QToolbar,QBreadcrumbs,QBreadcrumbsEl,QSpace,QBtn,QTable,QCard,QItem,QItemSection,QAvatar,QItemLabel,QSeparator,QCardSection,QImg,QCardActions})
